import { render, staticRenderFns } from "./F204.vue?vue&type=template&id=294186c4&scoped=true"
import script from "./F204.vue?vue&type=script&lang=js"
export * from "./F204.vue?vue&type=script&lang=js"
import style0 from "./F204.vue?vue&type=style&index=0&id=294186c4&prod&lang=css"
import style1 from "@/assets/css/Pdis.css?vue&type=style&index=1&id=294186c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294186c4",
  null
  
)

export default component.exports